"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import  Spddetailscontent from '../components/Spddetailscontent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import LightningProductsSubMenu from '../components/LightningProductsSubMenu';

import spdban from '../images/spd/spd_page_banner.jpg';
import spdban_360 from '../images/spd/spd_page_banner_360.jpg';
import spdban_tab from '../images/spd/spd_page_banner_tab.jpg';
import spdban2x from  '../images/spd/spd_page_banner@2x.jpg';

// import ProducthomeBanner from '../components/ProducthomeBanner';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const SpdPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    //setIpageValue(item);
    //console.log("set new ipaf vale "+item);
    
  };

    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok surge protection device (SPD) — Class B/C, EN 61643-11" bannertext="" ban1x={spdban} ban2x={spdban2x} ban360={spdban_360} bantab={spdban_tab}/>
            <ProductsubMenu/>
            <LightningProductsSubMenu onImageClick={handleItemClick}/>
          <Spddetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default SpdPage
 
